module.exports = __webpack_public_path__ + "media/application/images/icons/confidence-level-2-44f37eadc8f813ce8e8ad52a6b6ce109.svg";